export const ADD_COORDS = "ADD_COORDS";

export const ADD_CITY = "ADD_CITY"; 
